(function () {
  const menus = [
    {
      name: "Animation",
      options: [
        {
          name: "Digital Animation",
          options: [
            {
              name: "Krikey Animation Suite",
              type: "label",
            },
            {
              name: "GIFs",
              type: "item",
              link: "https://www.krikey.ai/features/transparent-gif",
              leftIcon: `
                          <div
                            class="dropdown-icon"
                            style="background-color: #BE4BDB;"
                          >
                <svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="16" width="16" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8 8h-2a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2v-4h-1"></path><path d="M12 8v8"></path><path d="M16 12h3"></path><path d="M20 8h-4v8"></path>
                </svg>
              </div>`,
              rightIcon: `<div class="dropdown-badge">NEW</div>`,
            },
            {
              name: "Custom Characters",
              type: "item",
              link: "https://www.krikey.ai/how-to/how-to-animate-a-custom-character-ai",
              leftIcon: `
                          <div
                            class="dropdown-icon"
                            style="background-color: #15aabf;"
                          >
                <svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="16" width="16" xmlns="http://www.w3.org/2000/svg"><path d="M20.955 11.104a9 9 0 1 0 -9.895 9.847"></path><path d="M9 10h.01"></path><path d="M15 10h.01"></path><path d="M9.5 15c.658 .672 1.56 1 2.5 1c.126 0 .251 -.006 .376 -.018"></path><path d="M18.42 15.61a2.1 2.1 0 0 1 2.97 2.97l-3.39 3.42h-3v-3l3.42 -3.39z"></path></svg>
              </div>`,
            },
            {
              name: "Social",
              type: "item",
              link: "https://www.krikey.ai/create/ai-funny-video-generator",
              leftIcon: `
                          <div
                            class="dropdown-icon"
                            style="background-color: #fab005;"
                          >
                <svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="16" width="16" xmlns="http://www.w3.org/2000/svg"><path d="M4 4m0 4a4 4 0 0 1 4 -4h8a4 4 0 0 1 4 4v8a4 4 0 0 1 -4 4h-8a4 4 0 0 1 -4 -4z"></path><path d="M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"></path><path d="M16.5 7.5l0 .01"></path></svg>
              </div>`,
            },
            {
              name: "Presentations",
              type: "item",
              link: "https://www.krikey.ai/features/how-to-animate-with-krikey-ai-magic-studio",
              leftIcon: `
                          <div
                            class="dropdown-icon"
                            style="background-color: #fd7e14;"
                          >
                <svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="16" width="16" xmlns="http://www.w3.org/2000/svg"><path d="M9 12v-4"></path><path d="M15 12v-2"></path><path d="M12 12v-1"></path><path d="M3 4h18"></path><path d="M4 4v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-10"></path><path d="M12 16v4"></path><path d="M9 20h6"></path></svg>
              </div>`,
            },
            {
              name: "Videos",
              type: "item",
              link: "https://www.krikey.ai/create/free-instagram-video-maker",
              leftIcon: `
                          <div
                            class="dropdown-icon"
                            style="background-color: #228be6;"
                          >
                <svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="16" width="16" xmlns="http://www.w3.org/2000/svg"><path d="M2 8a4 4 0 0 1 4 -4h12a4 4 0 0 1 4 4v8a4 4 0 0 1 -4 4h-12a4 4 0 0 1 -4 -4v-8z"></path><path d="M10 9l5 3l-5 3z"></path></svg>
              </div>`,
            },
            {
              name: "Character Poses",
              type: "item",
              link: "https://www.krikey.ai/features/how-to-use-the-krikey-ai-character-pose-generator",
              leftIcon: `
                          <div
                            class="dropdown-icon"
                            style="background-color: #7950f2;"
                          >
                <svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="16" width="16" xmlns="http://www.w3.org/2000/svg"><path d="M13 4m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path><path d="M4 17l5 1l.75 -1.5"></path><path d="M15 21l0 -4l-4 -3l1 -6"></path><path d="M7 12l0 -3l5 -1l3 3l3 1"></path></svg>
              </div>`,
            },
            {
              name: "Anime",
              type: "item",
              link: "https://www.krikey.ai/create/video-to-anime-converter",
              leftIcon: `
                          <div
                            class="dropdown-icon"
                            style="background-color: #12B886;"
                          >
                <svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="16" width="16" xmlns="http://www.w3.org/2000/svg"><path d="M6 21l12 -9"></path><path d="M6 12l12 9"></path><path d="M5 12h14"></path><path d="M6 3v9"></path><path d="M18 3v9"></path><path d="M6 8h12"></path><path d="M6 5h12"></path></svg>
              </div>`,
            },
            {
              name: "Animated Podcast",
              type: "item",
              link: "#need-to-make",
              leftIcon: `
                          <div
                            class="dropdown-icon"
                            style="background-color: #fa5252;"
                          >
                <svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="16" width="16" xmlns="http://www.w3.org/2000/svg"><path d="M9 2m0 3a3 3 0 0 1 3 -3h0a3 3 0 0 1 3 3v5a3 3 0 0 1 -3 3h0a3 3 0 0 1 -3 -3z"></path><path d="M5 10a7 7 0 0 0 14 0"></path><path d="M8 21l8 0"></path><path d="M12 17l0 4"></path></svg>
              </div>`,
            },
            {
              name: "Visual Effects",
              type: "item",
              link: "https://www.krikey.ai/case-studies/canva-animation",
              leftIcon: `
                          <div
                            class="dropdown-icon"
                            style="background-color: #e64980;"
                          >
                <svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="16" width="16" xmlns="http://www.w3.org/2000/svg"><path d="M3 12h18"></path><path d="M12 21v-18"></path><path d="M7.5 7.5l9 9"></path><path d="M7.5 16.5l9 -9"></path></svg>
              </div>`,
            },
            {
              name: "Popular in digital animation",
              type: "label",
            },
            {
              name: "Visual Resumes",
              type: "item",
              link: "https://www.krikey.ai/case-studies/small-business-animated-pitch-video",
            },
            {
              name: "Digital Invitations",
              type: "item",
              link: "https://www.krikey.ai/digital-invitations",
            },
            {
              name: "Emoji Maker",
              type: "item",
              link: "https://www.krikey.ai/create/how-to-make-a-slack-emoji",
            },
            {
              name: "AI Character Rigging",
              type: "item",
              link: "https://www.krikey.ai/create/character-rigging",
            },
            {
              name: "Motion Capture Tools",
              type: "item",
              link: "https://www.krikey.ai/learn/free-motion-capture-animation-tools",
            },
            {
              name: "Walk Cycle",
              type: "item",
              link: "https://www.krikey.ai/learn/walk-cycle",
            },
            {
              name: "Quick Animate",
              type: "item",
              link: "https://www.krikey.ai/AI-Text-To-Animation",
            },
          ],
        },
        {
          name: "Character AI Library",
          options: [
            {
              name: "Popular Characters",
              type: "label",
            },
            {
              name: "Character AI Store",
              type: "item",
              link: 'https://www.krikey.ai/3d-cartoon-character-store',
            },
            {
              name: "Animated Unicorn",
              type: "item",
              link: "https://www.krikey.ai/features/animated-unicorn-maker",
            },
            {
              name: "Cartoon Taco",
              type: "item",
              link: "https://www.krikey.ai/taco-tuesday-gifs",
            },
            {
              name: "Cartoon Teacher",
              type: "item",
              link: "https://www.krikey.ai/create/cartoon-teacher",
            },
            {
              name: "Cartoon Doctor",
              type: "item",
              link: "https://www.krikey.ai/create/cartoon-doctor-and-animated-doctor-videos",
            },
            {
              name: "Dancing Skeleton",
              type: "item",
              link: "https://www.krikey.ai/dancing-skeleton-gifs",
            },
            {
              name: "Tiger Mascot",
              type: "item",
              link: "https://www.krikey.ai/features/how-to-animate-a-tiger-mascot",
            },
            {
              name: "School Mascot",
              type: "item",
              link: "https://www.krikey.ai/learn/best-school-mascot-ideas-how-to-design-your-own-mascot",
            },
            {
              name: "NPC Characters",
              type: "item",
              link: "https://www.krikey.ai/learn/what-is-an-npc",
            },
            {
              name: "Anime Characters",
              type: "item",
              link: "https://www.krikey.ai/create/anime-ai-generator",
            },
            {
              name: "Video Game Characters",
              type: "item",
              link: "https://www.krikey.ai/create/ready-player-me-avatar-animation",
            },
            {
              name: "Vtuber Characters",
              type: "item",
              link: "https://www.krikey.ai/learn/best-vtuber-maker-animation-software",
            },
            {
              name: "Talking Avatars",
              type: "item",
              link: "https://www.krikey.ai/learn/how-to-make-a-talking-avatar",
            },
            {
              name: "Faceless YouTube Channel",
              type: "item",
              link: "https://www.krikey.ai/learn/how-to-make-a-faceless-youtube-channel",
            },
          ],
        },
        {
          name: "Images and GIFs",
          options: [
            {
              name: "Popular in Images & GIFs",
              type: "label",
            },
            {
              name: "Transparent GIF",
              type: "item",
              link: "https://www.krikey.ai/features/transparent-gif",
            },
            {
              name: "Character Pose Generator",
              type: "item",
              link: "https://www.krikey.ai/features/how-to-use-the-krikey-ai-character-pose-generator",
            },
            {
              name: "AI Image Generator",
              type: "item",
              link: "#need-to-make",
            },
            {
              name: "AI Background Generator",
              type: "item",
              link: "#need-to-make",
            },
            {
              name: "AI Character Generator",
              type: "item",
              link: "https://www.krikey.ai/create/ai-cartoon-generator",
            },
            {
              name: "Cricket Animation",
              type: "item",
              link: "https://www.krikey.ai/create/cricket-animation",
            },
            {
              name: "AI Animation for Kids",
              type: "item",
              link: "https://www.krikey.ai/create/ai-animation-for-kids",
            },
            {
              name: "AI Invitation Maker",
              type: "item",
              link: "https://www.krikey.ai/create/ai-invitation-maker",
            },
          ],
        },
        {
          name: "Video and Audio",
          options: [
            {
              name: "Popular in Video",
              type: "label",
            },
            {
              name: "Video Editor",
              type: "item",
              link: "https://www.krikey.ai/features/collaborative-video-editing",
            },
            {
              name: "Collaborative Video Editor",
              type: "item",
              link: "https://www.krikey.ai/features/collaborative-video-editing",
            },
            {
              name: "AI Text to Animation",
              type: "item",
              link: "https://www.krikey.ai/AI-Text-To-Animation",
            },
            {
              name: "AI Video to Animation",
              type: "item",
              link: "https://www.krikey.ai/case-studies/dance-animation-lesson-plans",
            },
            {
              name: "Resize Video",
              type: "item",
              link: "https://www.krikey.ai/3d-animation-editor",
            },
            {
              name: "AI Video Generator",
              type: "item",
              link: "https://www.krikey.ai/3d-animation-editor",
            },
            {
              name: "Popular in Audio",
              type: "label",
            },
            {
              name: "AI Text to Speech",
              type: "item",
              link: "https://www.krikey.ai/learn/ai-text-to-speech-characters",
            },
            {
              name: "Video Podcasts",
              type: "item",
              link: "#need-to-make",
            },
            {
              name: "AI Voice Generator",
              type: "item",
              link: "https://www.krikey.ai/learn/ai-text-to-speech-characters",
            },
          ],
        },
      ],
    },
    {
      name: "Product",
      options: [
        {
          name: "Animation Suite",
          options: [
            {
              name: "Animation Suite",
              type: "item",
              link: "https://www.krikey.ai/animation-app",
            },
            {
              name: "Krikey AI",
              type: "label",
            },
            {
              name: "Text to Animation",
              type: "item",
              link: "https://www.krikey.ai/3d-animation-editor",
            },
            {
              name: "Text to Speech",
              type: "item",
              link: "https://www.krikey.ai/learn/ai-text-to-speech-characters",
            },
            {
              name: "Magic Studio",
              type: "item",
              link: "https://www.krikey.ai/features/how-to-animate-with-krikey-ai-magic-studio",
            },
            {
              name: "Brand Mascot",
              type: "item",
              link: "https://www.krikey.ai/case-studies/animated-brand-mascot",
            },
            {
              name: "Translate",
              type: "item",
              link: "https://www.krikey.ai/case-studies/animation-connect-with-spanish-speaking-students",
            },
            {
              name: "AI Voice",
              type: "item",
              link: "https://www.krikey.ai/learn/ai-anime-voice-generator-tools",
            },
            {
              name: "Character AI",
              type: "item",
              link: "https://www.krikey.ai/learn/how-to-make-an-animated-person",
            },
            {
              name: "Video to Animation",
              type: "item",
              link: "https://www.krikey.ai/case-studies/dance-animation-lesson-plans",
            },
            {
              name: "Animation Kit",
              type: "item",
              link: "https://www.krikey.ai/3d-animation-editor",
            },
          ],
        },
      ],
    },
    {
      name: "Business",
      options: [
        {
          name: "Brand Management",
          link: "https://www.krikey.ai/case-studies",
        },
        {
          name: "Product Features",
          link: "https://www.krikey.ai/features",
        },
        {
          name: "App Partnerships",
          link: "https://www.krikey.ai/case-studies",
        },
        {
          name: 'Contact Sales',
          link: 'https://www.krikey.ai/contact-sales',
        },
        {
          name: "Business",
          options: [
            // {
            //   name: 'Book a Live Demo',
            //   link: 'https://www.krikey.ai/case-studies',
            // },
            {
              name: "Case Studies",
              link: "https://www.krikey.ai/case-studies",
            },
          ],
        },
      ],
    },
    {
      name: "Education",
      options: [
        {
          name: "Krikey for Education",
          link: "https://www.krikey.ai/back-to-school",
        },
        {
          name: "K-12 Education",
          link: "#need-to-make",
        },
        {
          name: "Higher Education",
          link: "#need-to-make",
        },
        {
          name: "Students",
          link: "#need-to-make",
        },
      ],
    },
    {
      name: 'Pricing',
      options: [
        {
          name: 'Compare Plans',
          link: 'https://www.krikey.ai/pricing',
        },
        {
          name: 'Free',
          link: 'https://www.krikey.ai/free',
        },
        {
          name: 'Pro',
          link: 'https://www.krikey.ai/pro',
        },
        {
          name: "Character AI Store",
          link: 'https://www.krikey.ai/3d-cartoon-character-store',
        },
      ],
    },
  ];

  function toggleMenu() {
    const drawerMenu = document.getElementById("drawer-menu");
    if (document.body.classList.contains("no-scroll")) {
      document.body.classList.remove("no-scroll");
      drawerMenu.classList.remove("drawer-menu-open");
    } else {
      document.body.classList.add("no-scroll");
      drawerMenu.classList.add("drawer-menu-open");
      loadMainMenuItems();
    }
  }
  const menuOpenButton = document.getElementById("menu-button");
  const drawerMenuOverlay = document.getElementById("drawer-menu-overlay");
  const drawerMenuClose = document.getElementById("drawer-menu-close");
  const drawerMenuBack = document.getElementById("drawer-menu-back");
  const drawerMenuLogin = document.querySelector(".drawer-menu-login");

  drawerMenuClose.addEventListener("click", toggleMenu);
  drawerMenuOverlay.addEventListener("click", toggleMenu);
  menuOpenButton.addEventListener("click", toggleMenu);

  function loadMainMenuItems() {
    drawerMenuLogin.style.display = "block";
    drawerMenuBack.style.display = "none";
    drawerMenuClose.style.display = "block";
    const drawerMenuItems = document.querySelector(".drawer-menu-items");
    drawerMenuItems.innerHTML = "";
    menus.forEach(function (menu) {
      const item = document.createElement("a");
      item.className = "drawer-menu-item drawer-menu-item-main";
      item.innerHTML = `${menu.name} ${
        menu.options
          ? '<svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="M9 6l6 6l-6 6"></path></svg>'
          : ""
      } `;
      if (!menu.options) {
        item.setAttribute("href", menu.link.replace('https://www.krikey.ai', ''));
        item.setAttribute("target", "_blank");
      } else {
        item.addEventListener("click", () => loadOptionMenu(menu));
      }
      drawerMenuItems.appendChild(item);
    });
  }

  function loadOptionMenu(option) {
    drawerMenuLogin.style.display = "none";
    const drawerMenuItems = document.querySelector(".drawer-menu-items");
    drawerMenuItems.innerHTML = "";
    drawerMenuBack.style.display = "block";
    drawerMenuClose.style.display = "none";
    const menuTitle = document.createElement("p");
    menuTitle.textContent = option.name;
    menuTitle.className = "drawer-menu-item drawer-menu-item-main";
    drawerMenuItems.appendChild(menuTitle);
    drawerMenuBack.addEventListener("click", function () {
      loadMainMenuItems();
    });
    option.options.forEach(function (menu) {
      const item = document.createElement("a");
      item.className = "drawer-menu-item drawer-menu-item-option";
      item.innerHTML = `${menu.name} ${
        menu.options
          ? '<svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="M9 6l6 6l-6 6"></path></svg>'
          : ""
      } `;
      if (!menu.options) {
        item.setAttribute("href", menu.link.replace('https://www.krikey.ai', ''));
        item.setAttribute("target", "_blank");
      } else {
        item.addEventListener("click", () => loadSubOptionMenu(menu, option));
      }
      drawerMenuItems.appendChild(item);
    });
  }

  function loadSubOptionMenu(option, previousOption) {
    const drawerMenuItems = document.querySelector(".drawer-menu-items");
    drawerMenuItems.innerHTML = "";
    drawerMenuBack.style.display = "block";
    drawerMenuClose.style.display = "none";
    const menuTitle = document.createElement("p");
    menuTitle.textContent = option.name;
    menuTitle.className = "drawer-menu-item drawer-menu-item-main";
    drawerMenuItems.appendChild(menuTitle);
    drawerMenuBack.addEventListener("click", function () {
      loadOptionMenu(previousOption);
    });
    option.options.forEach(function (menu) {
      if (menu.type === "label") {
        const menuLabel = document.createElement("p");
        menuLabel.textContent = menu.name;
        menuLabel.className = "drawer-menu-item drawer-menu-item-label";
        drawerMenuItems.appendChild(menuLabel);
        return;
      }
      const item = document.createElement("a");
      item.className = "drawer-menu-item drawer-menu-item-sub-option";
      item.innerHTML = `<div>${menu.leftIcon ?? ""} ${menu.name} </div> ${
        menu.rightIcon ?? ""
      }`;
      item.setAttribute("href", menu.link.replace('https://www.krikey.ai', ''));
      item.setAttribute("target", "_blank");
      drawerMenuItems.appendChild(item);
    });
  }
  loadMainMenuItems();
})();
